import { createContext, useContext } from 'react';

// Bridges shell-owned state (root route) to page content (rendered via
// <Outlet/>/$.tsx) now that pages no longer receive it as direct props from
// one parent component. See src/routes/__root.tsx for the provided value.
export const ShellContext = createContext(null);
export const useShell = () => useContext(ShellContext);
